import { mergeAttributes } from '@tiptap/core';
import TiptapLink from '@tiptap/extension-link';
import { Plugin } from '@tiptap/pm/state';
import { PluginKey } from '@tiptap/pm/state';
import { EditorView } from '@tiptap/pm/view';
import * as linkify from 'linkifyjs';

const customAutolink = () => {
	return new Plugin({
		key: new PluginKey('customAutolink'),
		appendTransaction(transactions, oldState, newState) {
			const docChanged = transactions.some((tr) => tr.docChanged);
			if (!docChanged) {
				return null;
			}

			const { doc, selection } = newState;
			const { empty, from } = selection;

			if (!empty) {
				return null;
			}

			const $from = selection.$from;
			const textFrom = $from.start();
			const textTo = from;

			if (textFrom === textTo) {
				return null;
			}

			const text = doc.textBetween(textFrom, textTo, ' ');

			const links = linkify.find(text);

			if (!links.length) {
				return null;
			}

			const lastLink = links[links.length - 1];

			const start = textFrom + lastLink.start;
			const end = textFrom + lastLink.end;

			if (end !== from) {
				return null;
			}

			const href = lastLink.href;

			const tr = newState.tr;

			return tr.addMark(start, end, newState.schema.marks.link.create({ href }));
		},
	});
};

export const Link = TiptapLink.extend({
	inclusive: false,

	parseHTML() {
		return [
			{
				tag: 'a[href]:not([data-type="button"]):not([href *= "javascript:" i])',
			},
		];
	},

	renderHTML({ HTMLAttributes }) {
		return [
			'a',
			mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
				class: 'link',
			}),
			0,
		];
	},

	addProseMirrorPlugins() {
		const { editor } = this;

		return [
			...(this.parent?.() || []),
			customAutolink(),
			new Plugin({
				props: {
					handleKeyDown: (view: EditorView, event: KeyboardEvent) => {
						const { selection } = editor.state;

						if (event.key === 'Escape' && selection.empty !== true) {
							editor.commands.focus(selection.to, { scrollIntoView: false });
						}

						return false;
					},
				},
			}),
		];
	},
});

export default Link;
